import { Box, Stack, Typography, useTheme } from "@mui/material";
import { CreatableSearchableSelect, DateInput, Input } from "components";
import { useGetCustomerDetails, useGlobalStore } from "controller";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { convertUTCtoTimezoneV2, dateTimeToUtcV2 } from "utilz/helpers";

export const CreateOidcSso = ({
  customerDetailsData,
}: {
  customerDetailsData: any;
}) => {
  const theme = useTheme();
  const {
    control,
    formState: { errors },
    getValues,
    setValue,
  } = useFormContext();
  const timezone = useGlobalStore((state) => state.timezone);
  const containerStyles = {
    padding: "16px 24px",
    border: `1px solid ${theme.palette.neutral["010"]}`,
    borderRadius: "8px",
    bgcolor: theme.palette.neutral.main,
  };

  return (
    <>
      <Stack
        sx={{
          gap: "16px",
          ...containerStyles,
        }}
      >
        <Typography variant="h6">Domain details</Typography>
        <Stack gap="16px">
          <Box sx={{}}>
            <CreatableSearchableSelect
              name={"domain"}
              label="Domain Name"
              placeholder="Enter domain name"
              control={control}
              options={customerDetailsData?.domain_name || []}
              errorMessage={errors?.domain?.message?.toString() || ""}
              error={errors?.domain ? true : false}
              fullWidth
            ></CreatableSearchableSelect>
          </Box>
          <Input
            name={"clientId"}
            label="Application (Client) ID"
            placeholder="Eg : e2wd145o-1a93-8c2f-346a-0851d1e48131"
            control={control}
            errorMessage={errors?.clientId?.message?.toString() || ""}
            error={errors?.clientId ? true : false}
            fullWidth
          ></Input>
          <Input
            name={"issuer"}
            label="OpenID Connect metadata document"
            placeholder="Eg : https://login.microsoftonline.com/xxxxxxxxxxxxxxxxx/v2.0/.well-known/openid-configuration"
            control={control}
            errorMessage={errors?.issuer?.message?.toString() || ""}
            error={errors?.issuer ? true : false}
            fullWidth
          ></Input>
        </Stack>
      </Stack>

      <Stack
        borderRadius="8px"
        sx={{
          gap: "16px",
          ...containerStyles,
        }}
      >
        <Typography variant="subtitle1">Client credentials</Typography>
        <Input
          name={"clientSecret"}
          label="Secret Value"
          placeholder="Eg : x172Q~Yid5PXNYnJ9WlQO_UsWBBT1-yefcjM6sek"
          control={control}
          // errorMessage={errors?.oidcSecret?.message?.toString() || ""}
          // error={errors?.oidcSecret ? true : false}
          errorMessage={errors?.clientSecret?.message?.toString() || ""}
          error={errors?.clientSecret ? true : false}
          fullWidth
          inputFieledSx={{ bgcolor: theme.palette.neutral.main }}
        ></Input>
        <Input
          name={"spEntityId"}
          label="Secret ID (Optional)"
          placeholder="Eg:7d1f71f3-d93a-4e55-v75d-98c54fo03f21"
          control={control}
          sx={{ width: "100%", gridColumn: "span 2" }}
          inputFieledSx={{ bgcolor: theme.palette.neutral.main }}
        ></Input>
        <DateInput
          disablePast
          label="Expiry Date"
          size="small"
          value={convertUTCtoTimezoneV2(getValues("expiry_date"), timezone)}
          timezone={timezone}
          sx={{
            backgroundColor: theme.palette.darkBg.main,
          }}
          onChangeHandler={(newValue) => {
            setValue("expiry_date", dateTimeToUtcV2(newValue, timezone), {
              shouldDirty: true,
            });
          }}
          slotProps={{
            popper: {
              placement: "left",
            },
          }}
        />
      </Stack>
    </>
  );
};
